// extracted by mini-css-extract-plugin
module.exports = {"brandLogoContainer":"AQ","title":"AR","isLongTitle":"AS"};